export default "__VITE_ASSET__DNj0SAy9__"